import BindersList from "../views/BindersList.vue"
import BindersCreate from "../views/BindersCreate.vue"
import BindersUpdate from "../views/BindersUpdate.vue"

export default [
	{
		path: "/:tenantId/binders",
		component: BindersList,
		meta: { featureId: "binders" },
		name: "BindersList"
	},
	{
		path: "/:tenantId/binders/create",
		component: BindersCreate,
		meta: { featureId: "binders" },
		name: "BindersCreate",
		props: true
	},
	{
		path: "/:tenantId/binders/update/:id",
		component: BindersUpdate,
		meta: { featureId: "binders" },
		name: "BindersUpdate",
		props: true
	}
]
